import { render, staticRenderFns } from "./NotifiesList.vue?vue&type=template&id=42c6f799&"
import script from "./NotifiesList.vue?vue&type=script&lang=js&"
export * from "./NotifiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports